/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle3, _path37, _path38, _circle4, _path39, _path40, _circle5, _circle6, _circle7, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _circle14, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _circle15, _circle16, _circle17, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _circle18, _circle19, _circle20, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196;
const NotSentFilled = /*#__PURE__*/React.forwardRef(function NotSentFilled(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.59L3.41 2 2 3.41l8 8L2.66 14.06a1 1 0 000 1.87l8.59 3.43L14.59 16 16 17.41l-3.37 3.37 3.44 8.59A1 1 0 0017 30h0a1 1 0 00.92-.66L20.6 22l8 8zM22.49 16.83l3.45-9.49a1 1 0 00-1.28-1.28L15.17 9.51z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotSentFilled.propTypes = iconPropTypes;
}
const Notebook = /*#__PURE__*/React.forwardRef(function Notebook(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V25a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28l.002,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Notebook.propTypes = iconPropTypes;
}
const NotebookReference = /*#__PURE__*/React.forwardRef(function NotebookReference(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 7.586 22 2 27.586 3.414 29 9 23.414 9 27 11 27 11 20 4 20zM19 10H26V12H19zM19 15H26V17H19zM19 20H26V22H19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H4A2.002,2.002,0,0,0,2,7V17H4V7H15V27H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM17,25V7H28l.0015,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotebookReference.propTypes = iconPropTypes;
}
const Notification = /*#__PURE__*/React.forwardRef(function Notification(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
      d: "M14.4,10.1L13,8.8V6.5c0-2.6-1.9-4.7-4.5-5v-1h-1v1C5,1.8,3,3.9,3,6.5v2.3l-1.4,1.3c-0.1,0.1-0.2,0.2-0.1,0.4V12 c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0.1,0h3.5C5.5,13.9,6.6,15,8,15s2.5-1.1,2.5-2.5H14c0.3,0,0.5-0.2,0.5-0.4c0,0,0,0,0-0.1v-1.5 C14.5,10.4,14.4,10.2,14.4,10.1z M8,14c-0.8,0-1.5-0.7-1.5-1.5h3C9.5,13.3,8.8,14,8,14z M13.5,11.5h-11v-0.8l1.3-1.4 C3.9,9.3,4,9.1,4,9V6.5c0-2.2,1.8-4,4-4s4,1.8,4,4V9c0,0.1,0.1,0.3,0.1,0.4l1.4,1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Notification.propTypes = iconPropTypes;
}
const NotificationFilled = /*#__PURE__*/React.forwardRef(function NotificationFilled(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A.9993.9993,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20A.9993.9993,0,0,0,28.707,19.293ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationFilled.propTypes = iconPropTypes;
}
const NotificationNew = /*#__PURE__*/React.forwardRef(function NotificationNew(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.5859V14H24v3a1,1,0,0,0,.293.707L27,20.4141V22H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13A7.9854,7.9854,0,0,1,20,6.0825V3.8467a9.896,9.896,0,0,0-3-.7959V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.293,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v1a5,5,0,0,0,10,0V24h7a1,1,0,0,0,1-1V20a1,1,0,0,0-.293-.707ZM19,25a3,3,0,0,1-6,0V24h6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "4"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationNew.propTypes = iconPropTypes;
}
const NotificationOff = /*#__PURE__*/React.forwardRef(function NotificationOff(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
      d: "M2.5 11.5v-.8l1.3-1.4C3.9 9.3 4 9.1 4 9V6.5c0-2.2 1.8-4 4-4 .9 0 1.8.3 2.5.9l.7-.7C10.5 2 9.5 1.6 8.5 1.5v-1h-1v1C5 1.8 3 3.9 3 6.5v2.3l-1.4 1.3c-.1.1-.2.2-.1.4v1H2.5zM13 8.8V6.5c0-.8-.2-1.6-.5-2.2L15 1.7 14.3 1 1 14.3 1.7 15l2.5-2.5h1.3C5.5 13.9 6.6 15 8 15s2.5-1.1 2.5-2.5H14c.3 0 .5-.2.5-.4 0 0 0 0 0-.1v-1.5c0-.1-.1-.3-.1-.4L13 8.8zM8 14c-.8 0-1.5-.7-1.5-1.5h3C9.5 13.3 8.8 14 8 14zM13.5 11.5H5.2L11.7 5C11.9 5.5 12 6 12 6.5V9c0 .1.1.3.1.4l1.4 1.3V11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5859V13a9.9217 9.9217 0 00-1.0833-4.5024L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a1 1 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zm8-3H11.4141L23.4119 10.0024A7.949 7.949 0 0124 13v4a1 1 0 00.293.707L27 20.4141zM7.707 17.707A1 1 0 008 17V13a8.0092 8.0092 0 018-8 7.9253 7.9253 0 014.9857 1.7681l1.4264-1.4263A9.934 9.934 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859l-3 3L4.4141 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationOff.propTypes = iconPropTypes;
}
const NotificationOffFilled = /*#__PURE__*/React.forwardRef(function NotificationOffFilled(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5859V13a9.8828 9.8828 0 00-1.0869-4.499L30 3.4141 28.5859 2 2 28.5859 3.4141 30l6-6H11v1a5 5 0 0010 0V24h7a1 1 0 001-1V20a.9993.9993 0 00-.293-.707zM19 25a3 3 0 01-6 0V24h6zM21.61 4.7383A9.9256 9.9256 0 0017 3.0508V1H15V3.0508A10.0136 10.0136 0 006 13v3.5859L3.293 19.293A.9993.9993 0 003 20v3a.9738.9738 0 00.0585.29z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationOffFilled.propTypes = iconPropTypes;
}
const NotificationCounter = /*#__PURE__*/React.forwardRef(function NotificationCounter(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,12v15H5V5h15v-2H5c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h22c1.1046,0,2-.8954,2-2v-15h-2Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "26.5",
    cy: "5.5",
    r: "3.5",
    strokeWidth: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NotificationCounter.propTypes = iconPropTypes;
}
const Number_0 = /*#__PURE__*/React.forwardRef(function Number_0(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11h0V21h4V11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_0.propTypes = iconPropTypes;
}
const Number_1 = /*#__PURE__*/React.forwardRef(function Number_1(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10V22h0V10m1-1H12v2h3V21H12v2h8V21H17V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_1.propTypes = iconPropTypes;
}
const Number_2 = /*#__PURE__*/React.forwardRef(function Number_2(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H12V17a2,2,0,0,1,2-2h4V11H12V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H14v4h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_2.propTypes = iconPropTypes;
}
const Number_3 = /*#__PURE__*/React.forwardRef(function Number_3(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H12v2h6v4H14v2h4v4H12v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_3.propTypes = iconPropTypes;
}
const Number_4 = /*#__PURE__*/React.forwardRef(function Number_4(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10v8h0V10m1-1H17v8H14V9H12V19h5v4h2V19h1V17H19V9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_4.propTypes = iconPropTypes;
}
const Number_5 = /*#__PURE__*/React.forwardRef(function Number_5(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H12V9h8v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_5.propTypes = iconPropTypes;
}
const Number_6 = /*#__PURE__*/React.forwardRef(function Number_6(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18,14H14V11h5V9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16A2,2,0,0,0,18,14Zm-4,7V16h4v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_6.propTypes = iconPropTypes;
}
const Number_7 = /*#__PURE__*/React.forwardRef(function Number_7(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 13 14 13 14 11 17.85 11 13 23 15.16 23 20 11 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_7.propTypes = iconPropTypes;
}
const Number_8 = /*#__PURE__*/React.forwardRef(function Number_8(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,2v4H14V11ZM14,21V17h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_8.propTypes = iconPropTypes;
}
const Number_9 = /*#__PURE__*/React.forwardRef(function Number_9(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2h4v3H13v2h5a2,2,0,0,0,2-2V11A2,2,0,0,0,18,9Zm0,7H14V11h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Number_9.propTypes = iconPropTypes;
}
const NumberSmall_0 = /*#__PURE__*/React.forwardRef(function NumberSmall_0(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v6h2V13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_0.propTypes = iconPropTypes;
}
const NumberSmall_1 = /*#__PURE__*/React.forwardRef(function NumberSmall_1(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_1.propTypes = iconPropTypes;
}
const NumberSmall_2 = /*#__PURE__*/React.forwardRef(function NumberSmall_2(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H13V17a2,2,0,0,1,2-2h2V13H13V11h4a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H15v2h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_2.propTypes = iconPropTypes;
}
const NumberSmall_3 = /*#__PURE__*/React.forwardRef(function NumberSmall_3(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H13v2h4v2H14v2h3v2H13v2h4a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_3.propTypes = iconPropTypes;
}
const NumberSmall_4 = /*#__PURE__*/React.forwardRef(function NumberSmall_4(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L17 15 15 15 15 11 13 11 13 17 17 17 17 21 19 21 19 11 17 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_4.propTypes = iconPropTypes;
}
const NumberSmall_5 = /*#__PURE__*/React.forwardRef(function NumberSmall_5(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H13V19h4V17H13V11h6v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_5.propTypes = iconPropTypes;
}
const NumberSmall_6 = /*#__PURE__*/React.forwardRef(function NumberSmall_6(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3v2H15v2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,17,21Zm-2-4v2h2V17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_6.propTypes = iconPropTypes;
}
const NumberSmall_7 = /*#__PURE__*/React.forwardRef(function NumberSmall_7(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 21L14.44 21 17 13 15 13 15 14 13 14 13 11 19 11 19 13 16.44 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_7.propTypes = iconPropTypes;
}
const NumberSmall_8 = /*#__PURE__*/React.forwardRef(function NumberSmall_8(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H15a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm0,2v2H15V13Zm-2,6V17h2v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_8.propTypes = iconPropTypes;
}
const NumberSmall_9 = /*#__PURE__*/React.forwardRef(function NumberSmall_9(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21H14V19h3V17H15a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v6A2,2,0,0,1,17,21Zm-2-8v2h2V13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  NumberSmall_9.propTypes = iconPropTypes;
}
const Object$1 = /*#__PURE__*/React.forwardRef(function Object(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6,3h4v2h-4v8c0,1.2002-.5425,2.2661-1.3823,3,.8398.7339,1.3823,1.7998,1.3823,3v8h4v2h-4c-1.103,0-2-.8975-2-2v-8c0-1.1025-.897-2-2-2v-2c1.103,0,2-.8975,2-2V5c0-1.1025.897-2,2-2ZM28,13V5c0-1.1025-.897-2-2-2h-4v2h4v8c0,1.2002.5425,2.2661,1.3823,3-.8398.7339-1.3823,1.7998-1.3823,3v8h-4v2h4c1.103,0,2-.8975,2-2v-8c0-1.1025.897-2,2-2v-2c-1.103,0-2-.8975-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Object$1.propTypes = iconPropTypes;
}
const ObjectStorage = /*#__PURE__*/React.forwardRef(function ObjectStorage(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8H22v6H16v8h8V16h6zM22 20H18V16h4zm6-6H24V10h4zM18 10H10V2h8zM12 8h4V4H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObjectStorage.propTypes = iconPropTypes;
}
const ObjectStorageAlt = /*#__PURE__*/React.forwardRef(function ObjectStorageAlt(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H14V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023A2.9578,2.9578,0,0,0,15,12a2.9578,2.9578,0,0,0-.0413-.4087L18.9626,9.189A2.9909,2.9909,0,1,0,18,7a2.9345,2.9345,0,0,0,.0415.4092L14.0376,9.8115a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,18,17a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,6Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,12,13Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,21,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObjectStorageAlt.propTypes = iconPropTypes;
}
const ObservedHail = /*#__PURE__*/React.forwardRef(function ObservedHail(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "23.5",
    r: "1.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "19.5",
    r: "1.5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "19.5",
    r: "1.5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.964 14.5H17.036V16.499H11.964z",
    transform: "rotate(-45 14.5 15.5)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 14.5H23.035999999999998V16.499H17.964z",
    transform: "rotate(-45 20.5 15.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObservedHail.propTypes = iconPropTypes;
}
const ObservedLightning = /*#__PURE__*/React.forwardRef(function ObservedLightning(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ObservedLightning.propTypes = iconPropTypes;
}
const Omega = /*#__PURE__*/React.forwardRef(function Omega(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7373,25A14.3093,14.3093,0,0,0,27,15C27,8.42,22.58,4,16,4S5,8.42,5,15A14.3093,14.3093,0,0,0,9.2627,25H4v2h8V24.7617A12.5683,12.5683,0,0,1,7,15c0-5.4673,3.5327-9,9-9s9,3.5327,9,9a12.5683,12.5683,0,0,1-5,9.7617V27h8V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Omega.propTypes = iconPropTypes;
}
const Opacity = /*#__PURE__*/React.forwardRef(function Opacity(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V10H6zM10 10H14V14H10zM14 6H18V10H14zM22 6H26V10H22zM6 14H10V18H6zM14 14H18V18H14zM22 14H26V18H22zM6 22H10V26H6zM14 22H18V26H14zM22 22H26V26H22zM18 10H22V14H18zM10 18H14V22H10zM18 18H22V22H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Opacity.propTypes = iconPropTypes;
}
const OpenPanelBottom = /*#__PURE__*/React.forwardRef(function OpenPanelBottom(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6ZM4,26V20H28v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelBottom.propTypes = iconPropTypes;
}
const OpenPanelFilledBottom = /*#__PURE__*/React.forwardRef(function OpenPanelFilledBottom(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V18H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledBottom.propTypes = iconPropTypes;
}
const OpenPanelFilledLeft = /*#__PURE__*/React.forwardRef(function OpenPanelFilledLeft(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledLeft.propTypes = iconPropTypes;
}
const OpenPanelFilledRight = /*#__PURE__*/React.forwardRef(function OpenPanelFilledRight(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledRight.propTypes = iconPropTypes;
}
const OpenPanelFilledTop = /*#__PURE__*/React.forwardRef(function OpenPanelFilledTop(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,26V14H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelFilledTop.propTypes = iconPropTypes;
}
const OpenPanelLeft = /*#__PURE__*/React.forwardRef(function OpenPanelLeft(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6h6V26H4ZM28,26H12V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelLeft.propTypes = iconPropTypes;
}
const OpenPanelRight = /*#__PURE__*/React.forwardRef(function OpenPanelRight(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6H20V26H4ZM28,26H22V6h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelRight.propTypes = iconPropTypes;
}
const OpenPanelTop = /*#__PURE__*/React.forwardRef(function OpenPanelTop(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2v6H4V6ZM4,26V14H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OpenPanelTop.propTypes = iconPropTypes;
}
const QOperation = /*#__PURE__*/React.forwardRef(function QOperation(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26L21 26 26 16 21 6 23 6 28 16 23 26zM4 6H6V26H4zM16 9H12a2 2 0 00-2 2V21a2 2 0 002 2h4a2 2 0 002-2V11A2 2 0 0016 9zm0 12H12V11h4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V17H13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperation.propTypes = iconPropTypes;
}
const QOperationGauge = /*#__PURE__*/React.forwardRef(function QOperationGauge(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L24 4 24 6 27.75 6 24 10 24 12 30 12 30 10 26.38 10 30 6 30 4zM20 17.62L22.08 14l-1.73-1-2.18 3.76A12 12 0 002 28H4a10 10 0 0113.16-9.48L14 24a2 2 0 102 2 2 2 0 00-.27-1L19 19.35A10 10 0 0124 28h2A12 12 0 0020 17.62z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperationGauge.propTypes = iconPropTypes;
}
const QOperationIf = /*#__PURE__*/React.forwardRef(function QOperationIf(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H14V23H12zM12 9H14V11H12zM23 11V9H20a2 2 0 00-2 2v2H16v2h2v8h2V15h3V13H20V11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QOperationIf.propTypes = iconPropTypes;
}
const OperationsField = /*#__PURE__*/React.forwardRef(function OperationsField(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H26V8H16z",
    transform: "rotate(-90 21 7)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z",
    transform: "rotate(-90 25 7)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H34V8H24z",
    transform: "rotate(-90 29 7)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a3.9123,3.9123,0,0,1-4-4,3.9123,3.9123,0,0,1,4-4V10a6,6,0,1,0,6,6H20A3.9123,3.9123,0,0,1,16,20Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8928,18.4536,26.0979,16,24.78,17.5044l2.7922,2.4517-2.36,4.0878-3.4273-1.1591a9.0315,9.0315,0,0,1-2.7143,1.5644L18.36,28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H16V2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18.36a2,2,0,0,0,1.9611-1.6079l.5037-2.5186a10.9666,10.9666,0,0,0,1.3267-.7534l2.4194.8184a1.9977,1.9977,0,0,0,2.3728-.8946l2.3606-4.0878A2.0006,2.0006,0,0,0,28.8928,18.4536Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OperationsField.propTypes = iconPropTypes;
}
const OperationsRecord = /*#__PURE__*/React.forwardRef(function OperationsRecord(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20zM20 24H30V26H20zM20 28H30V30H20zM16 20a3.9123 3.9123 0 01-4-4 3.9123 3.9123 0 014-4 3.9123 3.9123 0 014 4h2a6 6 0 10-6 6z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H16V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OperationsRecord.propTypes = iconPropTypes;
}
const OrderDetails = /*#__PURE__*/React.forwardRef(function OrderDetails(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H13a3 3 0 00-3 3v2h2V24a1 1 0 011-1h6a1 1 0 011 1v2h2V24A3 3 0 0019 21zM16 20a4 4 0 10-4-4A4 4 0 0016 20zm0-6a2 2 0 11-2 2A2 2 0 0116 14z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OrderDetails.propTypes = iconPropTypes;
}
const Ordinal = /*#__PURE__*/React.forwardRef(function Ordinal(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
      d: "M1,13 L1,12 L3,12 L3,9 L5.999,9 L6,6 L9,6 L9,3 L13,3 L13,12 L15,12 L15,13 L1,13 Z M5.999,10 L4,10 L4,12 L5.999,12 L5.999,10 Z M8.999,7 L6.999,7 L6.999,9 L7,9 L7,12 L8.999,12 L8.999,7 Z M12,4 L10,4 L10,12 L12,12 L12,4 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26V4H18v6H12v6H6V26H2v2H30V26ZM8,26V18h4v8Zm6,0V12h4V26Zm6,0V6h4V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ordinal.propTypes = iconPropTypes;
}
const Outage = /*#__PURE__*/React.forwardRef(function Outage(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H21V26H12zM13 28H19V30H13z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7832 18.9746l1.4177-1.418A6.9206 6.9206 0 018 12 7.99 7.99 0 0121.5273 6.2305l1.4136-1.4136A9.9884 9.9884 0 006 12 8.9411 8.9411 0 008.7832 18.9746zM30 3.4141L28.5859 2 2 28.5859 3.4141 30 23.6606 9.7534A7.7069 7.7069 0 0124 12a7.2032 7.2032 0 01-2.8223 6.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12a9.8739 9.8739 0 00-.7764-3.81z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Outage.propTypes = iconPropTypes;
}
const OutlookSevere = /*#__PURE__*/React.forwardRef(function OutlookSevere(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15.1249,19h1.75v5.5h-1.75ZM17,27a1,1,0,1,0-1,1A1,1,0,0,0,17,27Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9084,28.94,16.8318,14.4878a.9531.9531,0,0,0-1.6636,0L7.0916,28.94A.7122.7122,0,0,0,7.7134,30H24.2867A.7121.7121,0,0,0,24.9084,28.94ZM15.125,19h1.75v5.5h-1.75ZM16,28a1,1,0,1,1,1-1A1,1,0,0,1,16,28Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4926,6.4926,0,0,0,.9153,12.8443L9.2217,20H8.5a4.48,4.48,0,0,1-3.3693-7.4556l5.297,5.2964,1.013-1.8135-4.66-4.6606A4.402,4.402,0,0,1,8.144,11.019l.8155-.0639.0991-.812c.0237-.1944.0581-.3848.0972-.5733l3.78,3.7808,1.0138-1.815L9.936,7.522a7.0212,7.0212,0,0,1,1.9754-2.1968L25.8861,19.3A4.4594,4.4594,0,0,1,23.5,20h-.7239l1.107,1.98a6.4927,6.4927,0,0,0,.9177-12.8443Zm2.4994,8.75L13.7823,4.3682a6.9736,6.9736,0,0,1,9.16,5.7749l.0986.812.8154.0639A4.5171,4.5171,0,0,1,28,15.5,4.46,4.46,0,0,1,27.3,17.8862Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OutlookSevere.propTypes = iconPropTypes;
}
const OverflowMenuHorizontal = /*#__PURE__*/React.forwardRef(function OverflowMenuHorizontal(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuHorizontal.propTypes = iconPropTypes;
}
const OverflowMenuVertical = /*#__PURE__*/React.forwardRef(function OverflowMenuVertical(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuVertical.propTypes = iconPropTypes;
}
const Overlay = /*#__PURE__*/React.forwardRef(function Overlay(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Overlay.propTypes = iconPropTypes;
}
const Package = /*#__PURE__*/React.forwardRef(function Package(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Package.propTypes = iconPropTypes;
}
const PackageTextAnalysis = /*#__PURE__*/React.forwardRef(function PackageTextAnalysis(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22H19V24H13z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18v2h2v8c0 1.1025.8972 2 2 2h20c1.1028 0 2-.8975 2-2v-8h2v-2H2zm24 10H6v-8h20v8zM29 16h-5c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h5v2h-5v6h5v2zM18 6h-4v-4h-2v14h6c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-4 8v-6h4v6h-4zM8 6H3v2h5v2h-4c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h6V8c0-1.103-.8975-2-2-2zm0 8h-4v-2h4v2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PackageTextAnalysis.propTypes = iconPropTypes;
}
const PackageNode = /*#__PURE__*/React.forwardRef(function PackageNode(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,28H4c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h10c1.1028,0,2,.8972,2,2v4h12c1.1028,0,2,.8972,2,2v14c0,1.1028-.8972,2-2,2ZM4,12v14h24v-14H4Zm0-2h10v-4H4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PackageNode.propTypes = iconPropTypes;
}
const PageFirst = /*#__PURE__*/React.forwardRef(function PageFirst(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageFirst.propTypes = iconPropTypes;
}
const PageLast = /*#__PURE__*/React.forwardRef(function PageLast(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageLast.propTypes = iconPropTypes;
}
const PageBreak = /*#__PURE__*/React.forwardRef(function PageBreak(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageBreak.propTypes = iconPropTypes;
}
const PageNumber = /*#__PURE__*/React.forwardRef(function PageNumber(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageNumber.propTypes = iconPropTypes;
}
const WatsonHealthPageScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthPageScroll(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPageScroll.propTypes = iconPropTypes;
}
const PaintBrush = /*#__PURE__*/React.forwardRef(function PaintBrush(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrush.propTypes = iconPropTypes;
}
const PaintBrushAlt = /*#__PURE__*/React.forwardRef(function PaintBrushAlt(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrushAlt.propTypes = iconPropTypes;
}
const PalmTree = /*#__PURE__*/React.forwardRef(function PalmTree(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PalmTree.propTypes = iconPropTypes;
}
const PanHorizontal = /*#__PURE__*/React.forwardRef(function PanHorizontal(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanHorizontal.propTypes = iconPropTypes;
}
const PanVertical = /*#__PURE__*/React.forwardRef(function PanVertical(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanVertical.propTypes = iconPropTypes;
}
const PanelExpansion = /*#__PURE__*/React.forwardRef(function PanelExpansion(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanelExpansion.propTypes = iconPropTypes;
}
const Paragraph = /*#__PURE__*/React.forwardRef(function Paragraph(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paragraph.propTypes = iconPropTypes;
}
const Parameter = /*#__PURE__*/React.forwardRef(function Parameter(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Parameter.propTypes = iconPropTypes;
}
const ParentChild = /*#__PURE__*/React.forwardRef(function ParentChild(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ParentChild.propTypes = iconPropTypes;
}
const PartDefinition = /*#__PURE__*/React.forwardRef(function PartDefinition(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M20.8336 16.8081c-2.4408 0-3.8336.9114-3.8336 2.7507 0 1.5986 1.0315 2.6477 2.854 2.6477 1.3408 0 2.321-.6019 2.613-1.7539h.1034c.1371.9285.7216 1.5474 1.6675 1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052 0-2.8539.6879-3.5073 1.7194l1.3068 1.1689c.4296-.6189 1.0144-1.1344 2.0454-1.1344 1.1694 0 1.668.5844 1.668 1.5817v.6531h-1.5304zm1.5304 2.51c0 .8425-.7908 1.2893-1.7705 1.2893-.8601 0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002 1.7194-1.1002h1.4098v1.1862zM9.272 17.427h3.1287c2.218 0 3.5588-1.4785 3.5588-3.7133 0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573zm0-5.4501h2.9225c.8767 0 1.4098.4642 1.4098 1.3414v.7908c0 .8767-.5331 1.358-1.4098 1.358h-2.9225v-3.4902z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartDefinition.propTypes = iconPropTypes;
}
const PartUsage = /*#__PURE__*/React.forwardRef(function PartUsage(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M20.8336 16.8081c-2.4408 0-3.8336.9114-3.8336 2.7507 0 1.5986 1.0315 2.6477 2.854 2.6477 1.3408 0 2.321-.6019 2.613-1.7539h.1034c.1371.9285.7216 1.5474 1.6675 1.5474h1.2203v-1.7534h-.8938v-4.2292c0-2.0459-1.2891-3.1979-3.7133-3.1979-1.8052 0-2.8539.6879-3.5073 1.7194l1.3068 1.1689c.4296-.6189 1.0144-1.1344 2.0454-1.1344 1.1694 0 1.668.5844 1.668 1.5817v.6531h-1.5304zm1.5304 2.51c0 .8425-.7908 1.2893-1.7705 1.2893-.8601 0-1.3586-.3608-1.3586-1.0833v-.292c0-.7048.5679-1.1002 1.7194-1.1002h1.4098v1.1862zM9.272 17.427h3.1287c2.218 0 3.5588-1.4785 3.5588-3.7133 0-2.2181-1.3408-3.7137-3.5588-3.7137h-5.3981v12h2.2694v-4.573zm0-5.4501h2.9225c.8767 0 1.4098.4642 1.4098 1.3414v.7908c0 .8767-.5331 1.358-1.4098 1.358h-2.9225v-3.4902z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartUsage.propTypes = iconPropTypes;
}
const PartitionAuto = /*#__PURE__*/React.forwardRef(function PartitionAuto(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19c-2.2056 0-4 1.7944-4 4 0 .6836.1882 1.3174.4917 1.8809-1.8762 1.3726-4.146 2.1191-6.4917 2.1191-6.0654 0-11-4.9346-11-11h-2c0 7.168 5.8318 13 13 13 2.8455 0 5.5923-.936 7.8433-2.6416.6235.4019 1.3613.6416 2.1567.6416 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM16 3c-2.8455 0-5.5923.936-7.8433 2.6416-.6235-.4019-1.3613-.6416-2.1567-.6416-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4c0-.6836-.1882-1.3174-.4917-1.8809 1.8762-1.3726 4.146-2.1191 6.4917-2.1191 6.0654 0 11 4.9346 11 11h2c0-7.168-5.8318-13-13-13zM6 11c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionAuto.propTypes = iconPropTypes;
}
const PartitionCollection = /*#__PURE__*/React.forwardRef(function PartitionCollection(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-5.4143 5.4141H2v2h10.5857c.5344 0 1.0366-.208 1.4143-.5859l5.4143-5.4141h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM16.1717 14.5859l-3.5859-3.5859H2v-2h10.5857c.5344 0 1.0366.208 1.4143.5859l3.5859 3.5859-1.4143 1.4141z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionCollection.propTypes = iconPropTypes;
}
const PartitionRepartition = /*#__PURE__*/React.forwardRef(function PartitionRepartition(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-3.5864 3.5864 1.4141 1.4141 3.5867-3.5864h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM10.1716 17.4141l-3.5859 3.5859H2v2h4.5857c.5344 0 1.0366-.208 1.4143-.5859l3.5859-3.5859-1.4143-1.4141z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-11.4141-11.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h4.5859l11.4141,11.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionRepartition.propTypes = iconPropTypes;
}
const PartitionSame = /*#__PURE__*/React.forwardRef(function PartitionSame(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18c-1.8584 0-3.4106 1.2798-3.8579 3H2v2h20.1421c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM26 6c-1.8584 0-3.4106 1.2798-3.8579 3H2v2h20.1421c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSame.propTypes = iconPropTypes;
}
const PartitionSpecific = /*#__PURE__*/React.forwardRef(function PartitionSpecific(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18c-1.8584 0-3.4106 1.2798-3.8579 3h-2.728l-5.4141-5.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h10.5859l5.4141 5.4141c.3777.3779.8799.5859 1.4143.5859h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM26 6c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-3.5864 3.5864 1.4141 1.4141 3.5867-3.5864h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSpecific.propTypes = iconPropTypes;
}
const PartlyCloudy = /*#__PURE__*/React.forwardRef(function PartlyCloudy(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H31V17H27z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 5.794H27.329V7.794H23.086z",
    transform: "rotate(-45 25.207 6.794)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H17V5H15z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 24.208H8.915V26.208H4.672z",
    transform: "rotate(-45 6.793 25.208)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 4.672H7.793V8.915H5.793z",
    transform: "rotate(-45 6.793 6.794)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudy.propTypes = iconPropTypes;
}
const PartlyCloudyNight = /*#__PURE__*/React.forwardRef(function PartlyCloudyNight(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudyNight.propTypes = iconPropTypes;
}
const Partnership = /*#__PURE__*/React.forwardRef(function Partnership(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Partnership.propTypes = iconPropTypes;
}
const PassengerDrinks = /*#__PURE__*/React.forwardRef(function PassengerDrinks(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerDrinks.propTypes = iconPropTypes;
}
const PassengerPlus = /*#__PURE__*/React.forwardRef(function PassengerPlus(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerPlus.propTypes = iconPropTypes;
}
const Password = /*#__PURE__*/React.forwardRef(function Password(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Password.propTypes = iconPropTypes;
}
const Paste = /*#__PURE__*/React.forwardRef(function Paste(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paste.propTypes = iconPropTypes;
}
const Pause = /*#__PURE__*/React.forwardRef(function Pause(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
      d: "M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pause.propTypes = iconPropTypes;
}
const PauseFilled = /*#__PURE__*/React.forwardRef(function PauseFilled(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFilled.propTypes = iconPropTypes;
}
const PauseOutline = /*#__PURE__*/React.forwardRef(function PauseOutline(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
      d: "M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z"
    })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutline.propTypes = iconPropTypes;
}
const PauseOutlineFilled = /*#__PURE__*/React.forwardRef(function PauseOutlineFilled(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutlineFilled.propTypes = iconPropTypes;
}
const PauseFuture = /*#__PURE__*/React.forwardRef(function PauseFuture(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFuture.propTypes = iconPropTypes;
}
const PausePast = /*#__PURE__*/React.forwardRef(function PausePast(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PausePast.propTypes = iconPropTypes;
}
const PcnENode = /*#__PURE__*/React.forwardRef(function PcnENode(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnENode.propTypes = iconPropTypes;
}
const PcnMilitary = /*#__PURE__*/React.forwardRef(function PcnMilitary(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnMilitary.propTypes = iconPropTypes;
}
const PcnPNode = /*#__PURE__*/React.forwardRef(function PcnPNode(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnPNode.propTypes = iconPropTypes;
}
const PcnZNode = /*#__PURE__*/React.forwardRef(function PcnZNode(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnZNode.propTypes = iconPropTypes;
}
const Pdf = /*#__PURE__*/React.forwardRef(function Pdf(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pdf.propTypes = iconPropTypes;
}
const PdfReference = /*#__PURE__*/React.forwardRef(function PdfReference(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PdfReference.propTypes = iconPropTypes;
}
const Pedestrian = /*#__PURE__*/React.forwardRef(function Pedestrian(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pedestrian.propTypes = iconPropTypes;
}
const PedestrianFamily = /*#__PURE__*/React.forwardRef(function PedestrianFamily(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianFamily.propTypes = iconPropTypes;
}
const PedestrianChild = /*#__PURE__*/React.forwardRef(function PedestrianChild(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianChild.propTypes = iconPropTypes;
}
const Pen = /*#__PURE__*/React.forwardRef(function Pen(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M8.136 7.5H18.863999999999997V9.5H8.136z",
    transform: "rotate(-45 13.5 8.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pen.propTypes = iconPropTypes;
}
const PenFountain = /*#__PURE__*/React.forwardRef(function PenFountain(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PenFountain.propTypes = iconPropTypes;
}
const Pending = /*#__PURE__*/React.forwardRef(function Pending(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pending.propTypes = iconPropTypes;
}
const PendingFilled = /*#__PURE__*/React.forwardRef(function PendingFilled(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PendingFilled.propTypes = iconPropTypes;
}
const PentagonDownOutline = /*#__PURE__*/React.forwardRef(function PentagonDownOutline(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,27.7593l-11.8274-8.6831,4.5261-14.0762h14.6025l4.5261,14.0762-11.8274,8.6831m0,2.2407c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonDownOutline.propTypes = iconPropTypes;
}
const PentagonDownSolid = /*#__PURE__*/React.forwardRef(function PentagonDownSolid(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonDownSolid.propTypes = iconPropTypes;
}
const PentagonLeftOutline = /*#__PURE__*/React.forwardRef(function PentagonLeftOutline(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.2407,16L12.9238,4.1726l14.0762,4.5261v14.6025l-14.0762,4.5261-8.6831-11.8274m-2.2407,0c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonLeftOutline.propTypes = iconPropTypes;
}
const PentagonLeftSolid = /*#__PURE__*/React.forwardRef(function PentagonLeftSolid(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,16c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonLeftSolid.propTypes = iconPropTypes;
}
const PentagonOutline = /*#__PURE__*/React.forwardRef(function PentagonOutline(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,4.2407l11.8274,8.6831-4.5261,14.0762h-14.6025l-4.5261-14.0762,11.8274-8.6831m0-2.2407c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonOutline.propTypes = iconPropTypes;
}
const PentagonRightOutline = /*#__PURE__*/React.forwardRef(function PentagonRightOutline(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.7593,16l-8.6831,11.8274-14.0762-4.5261v-14.6025l14.0762-4.5261,8.6831,11.8274m2.2407,0c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonRightOutline.propTypes = iconPropTypes;
}
const PentagonRightSolid = /*#__PURE__*/React.forwardRef(function PentagonRightSolid(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonRightSolid.propTypes = iconPropTypes;
}
const PentagonSolid = /*#__PURE__*/React.forwardRef(function PentagonSolid(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PentagonSolid.propTypes = iconPropTypes;
}
const Percentage = /*#__PURE__*/React.forwardRef(function Percentage(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Percentage.propTypes = iconPropTypes;
}
const PercentageFilled = /*#__PURE__*/React.forwardRef(function PercentageFilled(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PercentageFilled.propTypes = iconPropTypes;
}
const Person = /*#__PURE__*/React.forwardRef(function Person(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Person.propTypes = iconPropTypes;
}
const PersonFavorite = /*#__PURE__*/React.forwardRef(function PersonFavorite(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PersonFavorite.propTypes = iconPropTypes;
}
const Pest = /*#__PURE__*/React.forwardRef(function Pest(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "21",
    r: "1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pest.propTypes = iconPropTypes;
}
const WatsonHealthPetImageB = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageB(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 3.07H13.57V6.07H11.59z",
    transform: "rotate(-45 12.586 4.577)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 17.92H28.42V20.92H26.44z",
    transform: "rotate(-45 27.43 19.408)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.42H14.09V20.400000000000002H11.09z",
    transform: "rotate(-45 12.592 19.414)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M25.93 3.58H28.93V5.5600000000000005H25.93z",
    transform: "rotate(-45 27.423 4.57)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageB.propTypes = iconPropTypes;
}
const WatsonHealthPetImageO = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageO(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 11.09H5.57V14.09H3.59z",
    transform: "rotate(-45 4.585 12.59)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 25.93H20.42V28.93H18.44z",
    transform: "rotate(-45 19.429 27.422)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09 26.44H6.09V28.42H3.09z",
    transform: "rotate(-45 4.591 27.428)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 11.59H20.93V13.57H17.93z",
    transform: "rotate(-45 19.423 12.585)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageO.propTypes = iconPropTypes;
}
const Phone = /*#__PURE__*/React.forwardRef(function Phone(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Phone.propTypes = iconPropTypes;
}
const PhoneApplication = /*#__PURE__*/React.forwardRef(function PhoneApplication(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneApplication.propTypes = iconPropTypes;
}
const PhoneBlock = /*#__PURE__*/React.forwardRef(function PhoneBlock(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlock.propTypes = iconPropTypes;
}
const PhoneBlockFilled = /*#__PURE__*/React.forwardRef(function PhoneBlockFilled(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlockFilled.propTypes = iconPropTypes;
}

export { NotSentFilled, Notebook, NotebookReference, Notification, NotificationCounter, NotificationFilled, NotificationNew, NotificationOff, NotificationOffFilled, NumberSmall_0, NumberSmall_1, NumberSmall_2, NumberSmall_3, NumberSmall_4, NumberSmall_5, NumberSmall_6, NumberSmall_7, NumberSmall_8, NumberSmall_9, Number_0, Number_1, Number_2, Number_3, Number_4, Number_5, Number_6, Number_7, Number_8, Number_9, Object$1 as Object, ObjectStorage, ObjectStorageAlt, ObservedHail, ObservedLightning, Omega, Opacity, OpenPanelBottom, OpenPanelFilledBottom, OpenPanelFilledLeft, OpenPanelFilledRight, OpenPanelFilledTop, OpenPanelLeft, OpenPanelRight, OpenPanelTop, OperationsField, OperationsRecord, OrderDetails, Ordinal, Outage, OutlookSevere, OverflowMenuHorizontal, OverflowMenuVertical, Overlay, Package, PackageNode, PackageTextAnalysis, PageBreak, PageFirst, PageLast, PageNumber, PaintBrush, PaintBrushAlt, PalmTree, PanHorizontal, PanVertical, PanelExpansion, Paragraph, Parameter, ParentChild, PartDefinition, PartUsage, PartitionAuto, PartitionCollection, PartitionRepartition, PartitionSame, PartitionSpecific, PartlyCloudy, PartlyCloudyNight, Partnership, PassengerDrinks, PassengerPlus, Password, Paste, Pause, PauseFilled, PauseFuture, PauseOutline, PauseOutlineFilled, PausePast, PcnENode, PcnMilitary, PcnPNode, PcnZNode, Pdf, PdfReference, Pedestrian, PedestrianChild, PedestrianFamily, Pen, PenFountain, Pending, PendingFilled, PentagonDownOutline, PentagonDownSolid, PentagonLeftOutline, PentagonLeftSolid, PentagonOutline, PentagonRightOutline, PentagonRightSolid, PentagonSolid, Percentage, PercentageFilled, Person, PersonFavorite, Pest, Phone, PhoneApplication, PhoneBlock, PhoneBlockFilled, QOperation, QOperationGauge, QOperationIf, WatsonHealthPageScroll, WatsonHealthPetImageB, WatsonHealthPetImageO };
